/* Web URLs */

/**
 * README !IMPORTANT
 *
 * DO NOT ADD ANY OTHER BASE_URL.
 * BASE_URL must always be `go` URL!
 */
const BASE_URL = 'https://go.pstmn.io';

export const CHANGELOG_URL = `${BASE_URL}/app-changelog`,
      EULA_LINK = `${BASE_URL}/eula`,
      HOME_PAGE_URL = `${BASE_URL}/home`,
      ISSUES_URL = `${BASE_URL}/app-issues`,
      LEARN_URL = `${BASE_URL}/learn`,
      LICENSE_URL = `${BASE_URL}/license`,
      LIKE_ICON_SVG = `${BASE_URL}/top-bar-icon`,
      PRO_API_LINK = `${BASE_URL}/postman-api-get-single-collection`,
      PRICING_LINK = `${BASE_URL}/pricing`,
      SUPPORT_URL = `${BASE_URL}/support`,
      TWITTER_URL = `${BASE_URL}/twitter`,
      PUBLIC_LIBRARY = `${BASE_URL}/public-library`,
      JOBS_URL = `${BASE_URL}/postman-jobs`,
      NATIVE_APPS_URL = `${BASE_URL}/native-apps`,
      UPDATE_FLOW_TROUBLESHOOT_LINK = `${BASE_URL}/update-flow-troubleshoot`,
      POSTMAN_COMMUNITY = `${BASE_URL}/community`,
      POSTMAN_ENTERPRISE = `${BASE_URL}/postman-enterprise/`,

/* Docs URLs */

      COLLECTION_DOCS = `${BASE_URL}/docs-collections`,
      DOCS_URL = `${BASE_URL}/docs`,
      DOCS_SECURITY_URL = `${BASE_URL}/security`,
      DOCS_SHARING_USING_LINK = `${BASE_URL}/docs-sharing-link`,
      DOCUMENTATION_LINK = `${BASE_URL}/docs-documentation`,
      ENV_SHARING_DOCS = `${BASE_URL}/docs-env-sharing`,
      MOCK_DOCS = `${BASE_URL}/docs-mocks`,
      INTRO_MOCK_DOCS = `${BASE_URL}/docs-intro-mocks`,
      MONITORING_DOCS = `${BASE_URL}/docs-monitoring`,
      PUBLISHING_DOCS = `${BASE_URL}/docs-publishing`,
      RIP_DOCS = `${BASE_URL}/docs-run-in-postman`,
      RUNNER_DOCS = `${BASE_URL}/docs-runner`,
      SHARING_LINK = `${BASE_URL}/docs-sharing`,
      SYNC_DOCS = `${BASE_URL}/docs-sync`,
      TEAM_LIBRARY_DOCS = `${BASE_URL}/docs-team-library`,
      TESTING_DOCS = `${BASE_URL}/docs-testing`,
      API_KEY_DOCS = `${BASE_URL}/api-key-docs`,
      ENVIRONMENT_DOCS = `${BASE_URL}/environment-docs`,
      GLOBAL_VARIABLE_DOCS = `${BASE_URL}/global-variable-docs`,
      VARIABLE_DOCS = `${BASE_URL}/docs-variables`,
      AUTH_DOCS = `${BASE_URL}/docs-auth`,
      POSTMAN_PRO_DOCS = `${BASE_URL}/docs-pro`,
      INVITE_USER_DOCS = `${BASE_URL}/docs-invite-user`,
      MARKDOWN_DOCS = `${BASE_URL}/markdown`,
      DOCUMENTATION_PUBLISH_DOCS = `${BASE_URL}/documentation-publish`,
      MANAGE_FOLDER_DOCS = `${BASE_URL}/folder-manage`,
      ADD_EXAMPLE_DOCS = `${BASE_URL}/docs-adding-example`,
      VIEW_DOCS = `${BASE_URL}/docs-view-documentation`,
      INTRO_API_DOCUMENTATION = `${BASE_URL}/docs-intro-api-documentation`,
      SAVE_REQUEST_DOCS = `${BASE_URL}/save-requests`,
      PRE_REQUEST_SCRIPT_DOCS = `${BASE_URL}/docs-prerequest-scripts`,
      TEST_SCRIPT_DOCS = `${BASE_URL}/docs-test-scripts`,
      REQUEST_DOCS = `${BASE_URL}/docs-requests`,
      PRO_API_AUTH_DOCS = `${BASE_URL}/docs-pro-api-auth`,
      PRO_API_KEYS_LINK = `${BASE_URL}/pro-api-keys`,
      EXAMPLE_DOCS = `${BASE_URL}/docs-examples`,
      DOCS = `${BASE_URL}/docs`,
      MONITORING_REGION_DOCS = `${BASE_URL}/docs-monitoring-regions`,
      INTEGRATION_DOCS = `${BASE_URL}/docs-integrations`,
      WORKSPACE_DOCS = `${BASE_URL}/docs-workspaces`,
      BROWSING_A_WORKSPACE_DOCS = `${BASE_URL}/docs-browsing-a-workspace`,
      SESSION_VARIABLE_DOCS = `${BASE_URL}/docs-session-variables`,
      ARCHIVED_RESOURCES_DOCS = `${BASE_URL}/docs-archived-resources`,
      INVITE_TO_WORKSPACE = `${BASE_URL}/docs-invite-to-workspace`,
      CERTIFICATES_DOC = `${BASE_URL}/docs-client-certs`,
      ACTIVITY_FEED_AND_RESTORING_COLLECTION = `${BASE_URL}/docs-activity-feed`,
      ACTIVITY_FEED_VERSION_TAGS = `${BASE_URL}/docs-activity-feed-tags`,
      ENABLE_SYNC_DOCS_URL = `${BASE_URL}/docs-enable-sync`,
      WORKING_WITH_COOKIES_DOCS_URL = `${BASE_URL}/docs-cookies`,
      WORKING_DIR_DOCS = `${BASE_URL}/docs-working-directory`,
      COOKIE_JAR_DOCS = `${BASE_URL}/docs-cookie-jar`,
      API_GENERATING_COLLECTION_FROM_SCHEMA = `${BASE_URL}/generating-collection-from-schema`,
      API_MOCK_SERVERS_DOCS_URL = `${BASE_URL}/docs-mock-servers-api`,
      API_DOCUMENTATION_DOCS_URL = `${BASE_URL}/docs-documentation-api`,
      API_ENVIRONMENT_DOCS_URL = `${BASE_URL}/docs-environment-api`,
      API_TEST_SUITE_DOCS_URL = `${BASE_URL}/docs-test-suite-api`,
      API_CONTRACT_TEST_DOCS_URL = `${BASE_URL}/docs-contract-test-api`,
      API_INTEGRATION_TEST_DOCS_URL = `${BASE_URL}/docs-integration-test-api`,
      API_MONITOR_DOCS_URL = `${BASE_URL}/docs-monitor-api`,
      INTERCEPTOR_DOCS_URL = `${BASE_URL}/interceptor-docs-link`,
      INTERCEPTOR_COOKIES_CAPTURE_URL = `${BASE_URL}/docs-interceptor-capture-cookies`,
      INTERCEPTOR_TROUBLESHOOTING_DOC = `${BASE_URL}/interceptor-installation-troubleshooting`,
      PROXY_INSTALL_ROOT_CA_DOCS_URL = `${BASE_URL}/docs-proxy-root-ca`,
      UPDATE_INTERCEPTOR_DOCS_URL = `${BASE_URL}/interceptor-extension-update`,
      VISUALIZER_DOCS_URL = `${BASE_URL}/docs-visualizer`,
      MOCKING_WITH_EXAMPLES = `${BASE_URL}/docs-mocking-with-examples`,
      PRO_API_INTRO = `${BASE_URL}/docs-pro-api-intro	`,
      CAPTURE_HTTP_REQUESTS_DOCS_URL = `${BASE_URL}/capture-docs-link`,
      CAPTURE_HTTPS_OPENSSL_REQ = `${BASE_URL}/docs-proxy-openssl-requirement`,
      ADD_API_NETWORK = `${BASE_URL}/add-to-api-network`,
      ADD_TEMPLATE = `${BASE_URL}/add-to-postman-templates`,
      SCHEMA_CHANGELOG = `${BASE_URL}/api-schema-changelog`,
      TROUBLESHOOTING_REQUEST = `${BASE_URL}/troubleshooting-request`,
      POSTMAN_AGENTS = `${BASE_URL}/docs-agents`,
      POSTMAN_DESKTOP_AGENT_DOCS = `${BASE_URL}/desktop-agent-docs`,
      INLINE_COMMENTS_DOC_URL = `${BASE_URL}/inline-comments`,
      DOCS_VARIABLE_SCOPES = `${BASE_URL}/docs-variable-scopes`,
      DEFINE_SCHEMA = `${BASE_URL}/define-schema`,
      SEND_FIRST_REQUEST_DOCS = `${BASE_URL}/docs-send-first-request`,
      CONVERT_COLLECTION_FORMAT_DOCS = `${BASE_URL}/convert-collection-format`,
      FEATURE_BRANCHES_DOCS = `${BASE_URL}/docs-feature-branches`,


/* Blog URLs */

      COLLECTION_V2_BLOG = `${BASE_URL}/collection-v2`,
      EXAMPLES_BLOG = `${BASE_URL}/learnexamples`,
      MOCKS_BLOG = `${BASE_URL}/learnmocks`,
      FIND_AND_REPLACE_BLOG = `${BASE_URL}/find-and-replace`,
      SYNC_FEEDBACK = `${BASE_URL}/sync-feedback`,
      COLLECTION_SCHEMA_SYNC_FEEDBACK = `${BASE_URL}/collection-schema-validation-feedback`,

/* Live Documentation  */
      LIVE_DOCS = `${BASE_URL}/live-docs-api`,

/* Empty Response illustration */
      EMPTY_RESPONSE = `${BASE_URL}/emptyResponse`,

/* External URLs */
      MARKDOWN_CHEAT_SHEET = `${BASE_URL}/markdown-cheatsheet`,
      WEBSOCKET_FEEDBACK = `${BASE_URL}/websocket-feedback`,
      FLOWS_FEEDBACK = `${BASE_URL}/flows-feedback`;
